module.exports = __webpack_public_path__ + "img/main-hero-2.b9d8c877.jpg";